import { CollectionDetail } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CollectionState {
  collectionDetails: CollectionDetail | null;
  collectionStatusList: { label: string; value: string }[];
  loading: boolean;
  error: string | null;
}

const initialState: CollectionState = {
  collectionDetails: null,
  collectionStatusList: [],
  loading: false,
  error: null,
};

const CollectionSlice = createSlice({
  name: "collectionInfo",
  initialState,
  reducers: {
    fetchCollectionStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCollectionSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.collectionDetails = action.payload;
    },
    fetchCollectionFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setCollectionStatusList(
      state,
      action: PayloadAction<{ label: string; value: string }[]>
    ) {
      state.collectionStatusList = action.payload;
    },
    clearCollection(state) {
      state.collectionDetails = null;
      state.collectionStatusList = [];
      state.error = null;
    },
  },
});

export const {
  fetchCollectionStart,
  fetchCollectionSuccess,
  fetchCollectionFailed,
  setCollectionStatusList,
  clearCollection,
} = CollectionSlice.actions;

export default CollectionSlice.reducer;
